import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Outlet, useLocation, useMatch } from 'react-router';

import { ROUTES } from '@crm/shared/routes';
import { TooltipProvider } from '@crm/shared/ui';
import { AppHeader, AppMenu } from '@crm/widgets';
import { BackNavigation } from '@crm/widgets/app-header/ui/BackNavigation';

export const RootLayout = () => {
    const isDealsPage = useMatch({ path: ROUTES.DEALS, end: true });
    const location = useLocation();
    const isFromAppMenu = (location.state as { fromAppMenu?: boolean } | null)?.fromAppMenu;

    return (
        <NuqsAdapter>
            <TooltipProvider>
                <div className="crm-root flex h-full w-full overflow-hidden">
                    <div className="flex h-full w-full min-w-0 flex-col overflow-hidden">
                        <AppHeader />
                        <main className="flex h-full min-h-0">
                            <AppMenu />
                            <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden px-8 py-4">
                                {!isDealsPage && !isFromAppMenu && <BackNavigation />}

                                <Outlet />
                            </div>
                        </main>
                        <footer className="shrink-0" />
                    </div>
                </div>
            </TooltipProvider>
        </NuqsAdapter>
    );
};
